import React from 'react';
import { motion } from 'framer-motion';
import { CircleIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
export function ObjecionesSection() {
  return <section className="w-full bg-[#A7C4A0]/20 py-20 md:py-28 px-4" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        {/* Objeción 1: Arroz */}
        <motion.div {...fadeInUp} className="mb-20" data-id="element-34">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg" data-id="element-35">
            <p className="text-[#C75B39] font-medium text-lg mb-4 italic" data-id="element-36">
              "Pero yo no puedo dejar el arroz / la arepa / la papa"
            </p>

            <h3 className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-6" data-id="element-37">
              Perfecto. No lo vas a dejar.
            </h3>

            <p className="text-[#1B4332]/80 text-lg leading-relaxed mb-8" data-id="element-38">
              Aquí entra la pieza que hace esto distinto a las guías genéricas:
            </p>

            <div className="bg-[#1B4332] rounded-2xl p-8 text-white" data-id="element-39">
              <h4 className="text-xl md:text-2xl font-bold mb-4 text-[#A7C4A0]" data-id="element-40">
                Reglas de Combinación Latina
              </h4>
              <p className="text-white/90 text-lg mb-6" data-id="element-41">
                No es "prohibido". Es <strong data-id="element-42">cómo</strong>.
              </p>
              <p className="text-white/80 leading-relaxed mb-6" data-id="element-43">
                Te enseño a armar un plato colombiano con arroz, arepa, papa,
                fríjol, panadería…
                <strong className="text-[#A7C4A0]" data-id="element-44">
                  {' '}
                  sin activar el caos.
                </strong>
              </p>
              <p className="text-white/70 italic" data-id="element-45">
                Porque el problema muchas veces no es el arroz. Es el arroz + la
                papa + el pan + la gaseosa + el afán.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Objeción 2: Tarde */}
        <motion.div {...fadeInUp} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-46">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg" data-id="element-47">
            <p className="text-[#C75B39] font-medium text-lg mb-4 italic" data-id="element-48">
              "¿Y si me levanto bien pero me inflo en la tarde?"
            </p>

            <h3 className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-6" data-id="element-49">
              Entonces eres la clienta exacta.
            </h3>

            <p className="text-[#1B4332]/80 text-lg leading-relaxed mb-8" data-id="element-50">
              Este protocolo está hecho para ese patrón, porque incluye:
            </p>

            <div className="bg-[#FAF3E0] rounded-2xl p-8" data-id="element-51">
              <h4 className="text-xl md:text-2xl font-bold text-[#1B4332] mb-6" data-id="element-52">
                Semáforo de Hinchazón
              </h4>

              <div className="space-y-4" data-id="element-53">
                <div className="flex items-center gap-4" data-id="element-54">
                  <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center" data-id="element-55">
                    <CircleIcon className="w-6 h-6 text-white fill-white" data-id="element-56" />
                  </div>
                  <div data-id="element-57">
                    <p className="font-semibold text-[#1B4332]" data-id="element-58">Verde</p>
                    <p className="text-[#1B4332]/70" data-id="element-59">sigue normal</p>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-60">
                  <div className="w-10 h-10 rounded-full bg-yellow-500 flex items-center justify-center" data-id="element-61">
                    <CircleIcon className="w-6 h-6 text-white fill-white" data-id="element-62" />
                  </div>
                  <div data-id="element-63">
                    <p className="font-semibold text-[#1B4332]" data-id="element-64">Amarillo</p>
                    <p className="text-[#1B4332]/70" data-id="element-65">ajusta sin pánico</p>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-66">
                  <div className="w-10 h-10 rounded-full bg-red-500 flex items-center justify-center" data-id="element-67">
                    <CircleIcon className="w-6 h-6 text-white fill-white ml-[10px] mr-[10px]" data-id="element-68" />
                  </div>
                  <div data-id="element-69">
                    <p className="font-semibold text-[#1B4332]" data-id="element-70">Rojo</p>
                    <p className="text-[#1B4332]/70 text-[14px] font-[400] pt-[0px] pb-[0px] pl-[0px] pr-[0px] ml-[0px] mr-[0px]" data-id="element-71">
                      protocolo 24 horas para bajar presión sin castigarte
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-[#1B4332]/70 mt-6 text-sm italic" data-id="element-72">
                Eso evita el ciclo más común: "me inflé → me odio → me restrinjo
                → reboto → me inflé peor".
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}